module.exports = __webpack_public_path__ + "img/login.dde0d675.png";